<template>
  <QrLanding />
</template>

<script>
import QrLanding from '../views/QrLanding.vue';

export default {
  name: 'AppQrLanding',
  components: { QrLanding },
};
</script>
